import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Card, Spin } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ILoginState } from '@share/store/slices';
import { axiosInstanceB2B } from '@share/utils';
import { Urls } from '@share/constants';
import { accountSettingActions } from '@store/slices';
import { BlueButton } from '@share/components';
import { FormattedMessage, useIntl } from 'react-intl';
import { getCompanyInfoForm } from '../../../../_mock-api\'s';

const { Option } = Select;

interface State {
  code: string;
  name: string;
}

interface Country {
  isZipRequired: boolean;
  isoCode: string;
  name: string;
  states: State[];
  zipRuleType: string;
}

interface IMapStateToProps {
  loginStore: ILoginState;
}

const CompanyCard: React.FC = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const [countries, setCountries] = useState<Country[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [accountData, setAccountData] = useState<any>();
  // const fetchCountries = async () => {
  //   try {
  //     setLoading(true);
  //     const result = await fetchCountriesData(
  //       API_END_POINT.FETCH_COUNTRIES,
  //       {},
  //       "post"
  //     );
  //     if (result?.rciCountries) {
  //       const uniqueCountries = Array.from(
  //         new Set(
  //           result?.rciCountries?.map((country: Country) => country?.isoCode)
  //         )
  //       )?.map((isoCode) => {
  //         return result?.rciCountries?.find(
  //           (country: Country) => country.isoCode === isoCode
  //         );
  //       });
  //       setCountries(uniqueCountries);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error parsing countries data:", error);
  //     setLoading(false);
  //   }
  // };

  const handleCountryChange = (value: string) => {
    const selectedCountry = countries?.find((country) => country?.isoCode === value);
    setStates(selectedCountry?.states || []);
    form.setFieldsValue({ state: undefined });
  };

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      try {
        const getAccountUser = await axiosInstanceB2B.get(
          `${Urls.FetchUserAccount}${login.account?.id}`,
          {},
        );
        dispatch(accountSettingActions.setPreferences(getAccountUser?.data?.preferences));
        // dispatch(accountSettingActions.setPreferences(preferences));
        setAccountData(getAccountUser.data);
      } catch (error) {
        console.error('Error fetching user data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const onFinish = async (values: any) => {
    setLoading(true);
    let createAccountPayload: any = {};
    createAccountPayload.email = values.email;
    createAccountPayload.name = values.name;
    createAccountPayload.id = accountData?.id;
    createAccountPayload.parentAccountId = accountData?.parentAccountId;
    createAccountPayload.preferences = accountData?.preferences;
    createAccountPayload.property = values.property;

    const payloadDataStringify = JSON.stringify(createAccountPayload);
    const formData = new FormData();
    formData.append('query', payloadDataStringify);
    try {
      // const result = await fetchSaveData(API_END_POINT.SAVE_USER_ACCOUNT, formData, 'post');
      // if (!result?.status) {
      //   toast.success('Company Information updated successfully', {
      //     theme: 'colored',
      //   });
      // }
    } catch (error) {
      console.error('Error saving data:', error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchCountries();
  // }, []);

  useEffect(() => {
    if (accountData) {
      const initialValues = {
        name: accountData?.name,
        email: accountData?.email,
        id: accountData?.id,
        accountId: accountData?.id,
        parentAccountId: accountData?.parentAccountId,
        baseAddressSite: accountData?.baseAddressSite,
        preferences: accountData?.preferences,
        property: accountData?.property,
      };
      form.setFieldsValue(initialValues);
    }
  }, [accountData]);

  const intl = useIntl();
  const companyInfoForm = getCompanyInfoForm(intl);
  return (
    <div className="card shadow-sm mb-5 border">
      <div className="card-header border-bottom">
        <h4 className="card-header-title">
        <i className="bi bi-building mx-2"></i><FormattedMessage id="company.information" />
        </h4>
      </div>

      <Spin spinning={loading}>
        <Form form={form} className="card-body p-4" layout="vertical" onFinish={onFinish}>
          <Card bordered={false} className="border-bottom mb-3">
            <div className="row">
              {companyInfoForm?.map((item, index) => (
                <div key={index} className={`col-md-${item.col} col-12`}>
                  <Form.Item
                    name={item.name}
                    label={item.label}
                    rules={[
                      {
                        required: item.required,
                        message: `${item.label} is required`,
                      },
                    ]}
                  >
                    {item.inputType === 'select' ? (
                      <Select
                        placeholder={item.placeholder}
                        onChange={item.name === 'country' ? handleCountryChange : undefined}
                        disabled={loading}
                      >
                        {item.name === 'country'
                          ? countries?.map((country) => (
                              <Option key={country.isoCode} value={country.isoCode}>
                                {country.name}
                              </Option>
                            ))
                          : states?.map((state) => (
                              <Option key={state.code} value={state.code}>
                                {state.name}
                              </Option>
                            ))}
                      </Select>
                    ) : (
                      <Input
                        type={item.inputType}
                        disabled={item.disabled}
                        placeholder={item.placeholder}
                        className="form-control form-control-lg"
                      />
                    )}
                  </Form.Item>
                </div>
              ))}
            </div>
          </Card>
          <div className="d-flex justify-content-end">
            <BlueButton
              block
              size="large"
              type="primary"
              htmlType="submit"
              className="btn btn-primary commonBlueBtn"
              disabled={loading}
            >
              <FormattedMessage id="save.changes" />
            </BlueButton>
          </div>
        </Form>
      </Spin>
    </div>
  );
};

export default CompanyCard;
